import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { AuthLayout } from 'layout';
import { LoginPage, RecoveryPasswordPage, NewPasswordPage } from 'pages';

const AuthRoutes = () => (
  <AuthLayout>
    <Switch>
      <Route path="/login" component={LoginPage} />
      <Route path="/restore" component={RecoveryPasswordPage} />
      <Route path="/newpassword/:token?" component={NewPasswordPage} />
      <Redirect to="/login" />
    </Switch>
  </AuthLayout>
);

export default AuthRoutes;
